import React, { useEffect, useRef } from 'react';

const SectionJotform = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://form.jotform.com/jsform/250996880146166';
    script.type = 'text/javascript';
    script.async = true;

    if (containerRef.current) {
      containerRef.current.innerHTML = ''; // Clear any existing embed
      containerRef.current.appendChild(script);
    }

    return () => {
      // Cleanup on unmount
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, []);

  return <div ref={containerRef} />;
};

export default SectionJotform;
